
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { TLoadable, isLoaded, createLoaded, isUnloaded, createLoading, createUnloaded } from "../../../../sg-core";
import { selectHavainnotState } from "../selectors";
import IPerson from "../../interfaces/IPerson";
import { createRequestFetchPersonsByProcessorRoleAction, createRequestFetchPersons } from "../actions/personAction";
import { useEffect } from "react";


// SELECTORS
const selectPersonsState = createSelector(
    selectHavainnotState,
    (workPermit) => workPermit.persons
);

export const selectPersonByIdState = createSelector(
    selectPersonsState,
    (state) => state.persons,
);

const selectPersonIdList = createSelector(
    selectPersonsState,
    (state) => state.personList,
)

const selectProcessorPersonIdList = createSelector(
    selectPersonsState,
    (state) => state.personListWithProcessorRole,
)

const getLoadedPersons = (personList: number[], byId: { [key: string]: TLoadable<IPerson> }) => {
    return personList.reduce<IPerson[]>((acc, id) => {
        let person = byId[id]
        return isLoaded(person) ? [...acc, person.data] : acc;
    }, []);
}

const selectPersonList = createSelector(
    selectPersonIdList,
    selectPersonByIdState,
    (personList, persons): TLoadable<IPerson[]> => {
        if (isLoaded(personList)) {
            return createLoaded(getLoadedPersons(personList.data, persons))
        }
        return personList as TLoadable<IPerson[]>
    },
);

const selectProcessorPersonList = createSelector(
    selectProcessorPersonIdList,
    selectPersonByIdState,
    (personList, persons): TLoadable<IPerson[]> => {
        if (isLoaded(personList)) {
            return createLoaded(getLoadedPersons(personList.data, persons).filter((person) => person));
        }
        return personList as TLoadable<IPerson[]>
    },
);
// HOOKS
export const usePersonList = (): TLoadable<IPerson[]> => useSelector(selectPersonList) as any;
export const useProcessorPersonList = (): TLoadable<IPerson[]> => {
    const dispatch = useDispatch()
    const personList = useSelector(selectProcessorPersonList);
    if (isUnloaded(personList)) {
        dispatch(createRequestFetchPersonsByProcessorRoleAction());
        return createLoading();
    }
    return personList
};

export const usePersonById = (personId: number): IPerson | undefined => {
    const persons = useSelector(selectPersonByIdState);
    const person = persons[personId]
    return person && isLoaded(person) ? person.data : undefined;
};

export const useLodablePersonById = (personId: number): TLoadable<IPerson> => {
    const persons = useSelector(selectPersonByIdState);
    const dispatch = useDispatch()
    const person = persons[personId]


    useEffect(() => {
        if (!person || isUnloaded(person)) {
            dispatch(createRequestFetchPersons([personId]))
        }
    }, [dispatch, personId, person]);

    if (!person) {
        return createUnloaded()
    }

    return person
};
/*
export const usePersonListByProcessorRole = (): TLoadable<IPerson[]> => {
};
*/